import React, { useState, useEffect } from 'react';
import DesktopVersion from './desktop-version';
import MobileVersion from './mobile-version';

const ParceriaRestaurantes = () => {
  // State to track if the device is mobile
  const [isMobile, setIsMobile] = useState(false);

  // Function to check if the device is mobile based on screen width
  const checkIsMobile = () => {
    setIsMobile(window.innerWidth <= 768); // Common breakpoint for mobile devices
  };

  // Set up event listener for window resize
  useEffect(() => {
    // Check initially on component mount
    checkIsMobile();

    // Add event listener for window resize
    window.addEventListener('resize', checkIsMobile);

    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener('resize', checkIsMobile);
    };
  }, []);

  // Render the appropriate version based on device type
  return isMobile ? <MobileVersion /> : <DesktopVersion />;
};

export default ParceriaRestaurantes; 